export default __webpack_public_path__ + "static/media/kafka.31b4a8cc.svg";